export const Step1 = ({ f, setF, toggle, valid, onNext }) => (
  <div className="rise">
    <h1 className="text-4xl sm:text-5xl mt-4 text-bone" style={{ fontWeight: 500 }}>Your profile</h1>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">How do you invest</h2>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {["individual", "entity"].map((t) => (
          <button key={t} className={`option-card ${f.investor_type === t ? "selected" : ""}`}
            onClick={() => setF({ ...f, investor_type: t })} data-testid={`onboarding-type-${t}`}>
            <span className="t-body capitalize">{t === "entity" ? "Through an entity" : "As an individual"}</span>
          </button>
        ))}
      </div>
      {f.investor_type === "entity" && (
        <input className="input-solera mt-3" placeholder="Entity name" value={f.entity_name}
          onChange={(e) => setF({ ...f, entity_name: e.target.value })} data-testid="onboarding-entity-input" />
      )}
    </div>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Regions</h2>
      <p className="t-small text-muted-s mt-2">Where you are open to transacting.</p>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {["US", "International"].map((r) => (
          <button key={r} className={`option-card ${f.regions.includes(r) ? "selected" : ""}`}
            onClick={() => toggle("regions", r)} data-testid={`onboarding-region-${r.toLowerCase()}`}>
            <span className="t-body">{r}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="mt-12">
      <button className={`option-card ${f.accredited ? "selected" : ""}`}
        onClick={() => setF({ ...f, accredited: !f.accredited })} data-testid="onboarding-accredited-toggle">
        <span className="t-body">I confirm I am an accredited investor</span>
        <p className="t-small text-muted-s mt-2">
          Directed only to accredited investors in jurisdictions where no licence is
          required to transact in private securities.
        </p>
      </button>
    </div>

    <button className="btn-primary w-full mt-12" disabled={!valid}
      onClick={onNext} data-testid="onboarding-next-button">Continue</button>
  </div>
);
